export class PromoCodeController {
    constructor(promoCodeService, cartService) {
        'ngInject';
        this.data = promoCodeService.data;

        Object.assign(this, {
            cartService,
            promoCodeService
        });
    }

    $onInit() {
        this.isLoading = true;
        this.data.displayedCode = '';
        this.cartService.getCart()
            .then(() => this._initPromoCode)
            .finally(() => this.isLoading = false);
    }

    _initPromoCode() {
        if (!this.cartService.data.cart.check.promoCodeDiscount) {
            this.data.appliedCode = '';
        }
    }

    applyPromoCode() {
        if (this.isLoading) {
            return;
        }

        this.isLoading = true;
        this.promoCodeService
            .applyPromoCode()
            .finally(() => this.isLoading = false);
    }

    wouldApplyNewPromoCode() {
        return this.data.appliedCode !== '' && this.data.displayedCode !== '';
    }
}
